/** PT → EN: nomes de itens usados nos kits (modal "Ver kit", listas dos cartões VIP). */
/* Os nomes do Kit Apoiador (Rifle de Assalto, Bandagens, Botas, Blusão, ...) estão em ../items.js. */
export default {
    // Planos Bronze / Prata / Ouro (vipKitConfig.js)
    "Rifle semiautomático": "Semi-Automatic Rifle",
    "Kits médicos": "Large Medkits",
    "Barricadas de madeira": "Wooden Barricade Covers",
    "Bandana": "Bandana Mask",
    "Jaqueta": "Jacket",
    "Saia de placas": "Wood Armor Pants",
    "Capacete de manifestação": "Riot Helmet",
    "Panos": "Cloth",
    "Saco de dormir": "Sleeping Bag",
    "Fuzil M39": "M39 Rifle",
    "Luvas de sinal de trânsito": "Roadsign Gloves",
    "Capacete de lata de café": "Coffee Can Helmet",
    "Munição 9 mm": "Pistol Bullet",
    "Rifle de precisão": "Bolt Action Rifle",
    "Muro alto de pedra": "High External Stone Wall",
    "Abóbora": "Pumpkin",
    "Abóboras": "Pumpkins",
    "Chá de sucata puro": "Pure Scrap Tea",
    "Chá de minério puro": "Pure Ore Tea",
    "Chá de cura puro": "Pure Max Health Tea",

    // LABEL_OVERRIDES (vipKitConfig.js)
    "LR-300 (Gelo)": "LR-300 (Ice)",
    "AK-47": "AK-47",
    "Rifle de assalto (MP5)": "Assault Rifle (MP5)",
    "Sucata": "Scrap",
    "Granada F1": "F1 Grenade",
    "Mesa de trabalho nível 3": "Work Bench Level 3",
    "Airdrop": "Airdrop",
    "Gerador": "Small Generator",
    "Fliperama Chippy": "Chippy Arcade Game",
    "Trono de gelo": "Ice Throne",
    "Ovo de ouro": "Golden Egg",
    "Grande presente": "Large Present",
    "Frango assado": "Cooked Chicken",
    "Chá de madeira puro": "Pure Wood Tea",
    "Máscara de gelo": "Ice Facemask",
    "Colete de gelo": "Ice Chestplate",
    "Saia de placas (madeira)": "Wood Armor Pants",
    "Caixa de madeira grande": "Large Wood Box",
    "Granada de fumo": "Smoke Grenade",
    "Gerador de teste": "Test Generator",
    "Mochila Pequena": "Small Backpack",
    "Mochila Grande": "Large Backpack",
};
